"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIInputStaticLabel = _interopRequireDefault(require("UIComponents/input/UIInputStaticLabel"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFileAttachment = _interopRequireDefault(require("UIComponents/attachment/UIFileAttachment"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _url = require("../../utils/url");

var _link = require("../../constants/link");

var _StyleProtectedSelectItem = _interopRequireDefault(require("../style-protected/StyleProtectedSelectItem"));

var _PageLinkField = _interopRequireDefault(require("./PageLinkField"));

var _MeetingLinkField = _interopRequireDefault(require("./MeetingLinkField"));

var _requiredBy = _interopRequireDefault(require("../../utils/requiredBy"));

var _AnchorLinkField = _interopRequireDefault(require("./AnchorLinkField"));

var _anchor = require("../../utils/anchor");

var _link2 = require("../../utils/link");

var _FormLabelWithHelpLink = _interopRequireDefault(require("../FormLabelWithHelpLink"));

var _EmailSubscriptionLinkField = _interopRequireDefault(require("./EmailSubscriptionLinkField"));

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var UrlPreview = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "LinkFields__UrlPreview",
  componentId: "sc-1cg13re-0"
})(["float:right;padding-top:12px;"]);

var LinkFields = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LinkFields, _Component);

  function LinkFields() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkFields)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleLinkTypeChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.onLinkTypeChange(value);
    };

    _this.handleFileSelection = function () {
      var _this$props = _this.props,
          onSelectFile = _this$props.onSelectFile,
          onUpdate = _this$props.onUpdate;
      onSelectFile(function (file) {
        onUpdate({
          href: file.url,
          linkDisplayName: file.title + "." + file.extension,
          fileMeta: {
            fileName: file.title + "." + file.extension,
            size: file.size,
            type: file.type
          }
        });
      });
    };

    return _this;
  }

  (0, _createClass2.default)(LinkFields, [{
    key: "renderUrlSearchInput",
    value: function renderUrlSearchInput() {
      var _this$props2 = this.props,
          href = _this$props2.href,
          onUpdate = _this$props2.onUpdate,
          linkType = _this$props2.linkType,
          shouldAutoFocus = _this$props2.shouldAutoFocus,
          isValidLink = _this$props2.isValidLink,
          useContextualToolbar = _this$props2.useContextualToolbar;

      var UrlFormControl = _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.URL + ".label")),
        className: "m-top-0",
        error: !isValidLink,
        validationMessage: isValidLink ? '' : _I18n.default.text(i18nKey('invalidLinkMessage'))
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: shouldAutoFocus,
        "data-test-id": "url-search-input",
        value: linkType === _link.LinkTypes.URL ? href : '',
        onKeyDown: this.props.onUrlKeyDown,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          // may want to save protocol appending for onRemove so it doesn't just suddenly add it while typing
          var newHref = (0, _url.isLikelyUrlWithoutProtocol)(value) ? "http://" + value : value;
          onUpdate({
            href: newHref,
            linkDisplayName: newHref
          });
        }
      }));

      if (useContextualToolbar) {
        return _react.default.createElement("div", null, _react.default.createElement(UrlPreview, null, _react.default.createElement(_UILink.default, {
          external: true,
          href: href,
          disabled: !href
        }, _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey("linkTypes." + _link.LinkTypes.URL + ".preview")
        }))), UrlFormControl);
      }

      return UrlFormControl;
    }
  }, {
    key: "renderEmailInput",
    value: function renderEmailInput() {
      var _this$props3 = this.props,
          href = _this$props3.href,
          onUpdate = _this$props3.onUpdate,
          shouldAutoFocus = _this$props3.shouldAutoFocus,
          isValidLink = _this$props3.isValidLink;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL + ".label")),
        className: "m-top-0",
        error: !isValidLink,
        validationMessage: isValidLink ? '' : _I18n.default.text(i18nKey('invalidLinkMessage'))
      }, _react.default.createElement(_UIInputStaticLabel.default, {
        text: 'mailto:',
        position: "start"
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: shouldAutoFocus,
        onKeyDown: this.props.onUrlKeyDown,
        "data-test-id": "email-address-input",
        value: href.replace(/^mailto:/, ''),
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          var newValue = value.replace(/^mailto:/, '');
          var newHref = "mailto:" + newValue;
          onUpdate({
            href: newHref,
            linkDisplayName: newValue
          });
        }
      })));
    }
  }, {
    key: "renderPageSelection",
    value: function renderPageSelection() {
      var _this$props4 = this.props,
          href = _this$props4.href,
          onUpdate = _this$props4.onUpdate,
          linkType = _this$props4.linkType,
          dropdownClassName = _this$props4.dropdownClassName,
          fetchPages = _this$props4.fetchPages,
          shouldAutoFocus = _this$props4.shouldAutoFocus;
      return _react.default.createElement(_PageLinkField.default, {
        autoFocus: shouldAutoFocus,
        url: linkType === _link.LinkTypes.PAGE ? href : '',
        fetchPages: fetchPages,
        dropdownClassName: dropdownClassName,
        onChange: function onChange(_ref4) {
          var url = _ref4.url,
              pageName = _ref4.pageName;
          onUpdate({
            href: url,
            linkDisplayName: pageName
          });
        }
      });
    }
  }, {
    key: "renderFileSelection",
    value: function renderFileSelection() {
      var _this2 = this;

      var _this$props5 = this.props,
          currentFileMeta = _this$props5.currentFileMeta,
          useContextualToolbar = _this$props5.useContextualToolbar;
      return _react.default.createElement("div", null, _react.default.createElement(_FormLabelWithHelpLink.default, {
        primaryText: i18nKey("linkTypes." + _link.LinkTypes.FILE + ".label"),
        linkText: currentFileMeta ? i18nKey("linkTypes." + _link.LinkTypes.FILE + ".replace") : null,
        onLinkClick: this.handleFileSelection
      }), currentFileMeta ? _react.default.createElement(_UIFileAttachment.default, {
        className: "hs-link-field--file-attachment",
        size: useContextualToolbar ? 'small' : undefined,
        onCloseClick: function onCloseClick() {
          return _this2.props.onUpdate({
            fileMeta: null,
            href: ''
          });
        },
        fileName: currentFileMeta.fileName,
        fileInfo: _I18n.default.formatSize(currentFileMeta.size),
        fileType: currentFileMeta.type,
        closeable: true
      }) : _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        onClick: this.handleFileSelection,
        size: "small"
      }, _I18n.default.text(i18nKey('selectFile'))));
    }
  }, {
    key: "renderEmailSubscriptionSelection",
    value: function renderEmailSubscriptionSelection() {
      var _this$props6 = this.props,
          href = _this$props6.href,
          onUpdate = _this$props6.onUpdate,
          linkType = _this$props6.linkType,
          dropdownClassName = _this$props6.dropdownClassName,
          emailSubscriptionLinkTypes = _this$props6.emailSubscriptionLinkTypes;
      return _react.default.createElement(_EmailSubscriptionLinkField.default, {
        onUpdate: onUpdate,
        href: href,
        linkType: linkType,
        dropdownClassName: dropdownClassName,
        emailSubscriptionLinkTypes: emailSubscriptionLinkTypes
      });
    }
  }, {
    key: "renderMeetingSelection",
    value: function renderMeetingSelection() {
      var _this$props7 = this.props,
          userId = _this$props7.userId,
          href = _this$props7.href,
          fetchMeetingsByUsers = _this$props7.fetchMeetingsByUsers,
          dropdownClassName = _this$props7.dropdownClassName,
          onUpdate = _this$props7.onUpdate;
      return _react.default.createElement(_MeetingLinkField.default, {
        userId: userId,
        url: href,
        fetchMeetingsByUsers: fetchMeetingsByUsers,
        dropdownClassName: dropdownClassName,
        onChange: function onChange(_ref5) {
          var url = _ref5.url,
              meetingName = _ref5.meetingName;
          return onUpdate({
            href: url,
            linkDisplayName: meetingName
          });
        }
      });
    }
  }, {
    key: "renderAnchorInput",
    value: function renderAnchorInput() {
      var _this$props8 = this.props,
          href = _this$props8.href,
          fetchAnchors = _this$props8.fetchAnchors,
          onUpdate = _this$props8.onUpdate,
          dropdownClassName = _this$props8.dropdownClassName;
      return _react.default.createElement(_AnchorLinkField.default, {
        anchor: (0, _anchor.deserializeAnchorFromLink)(href),
        fetchAnchors: fetchAnchors,
        dropdownClassName: dropdownClassName,
        onChange: function onChange(_ref6) {
          var anchorName = _ref6.anchorName;
          onUpdate({
            href: (0, _anchor.serializeAnchorAsLink)(anchorName),
            linkDisplayName: anchorName
          });
        }
      });
    }
  }, {
    key: "renderNoLinkInput",
    value: function renderNoLinkInput() {
      var useContextualToolbar = this.props.useContextualToolbar;
      if (!useContextualToolbar) return null;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey('linkTypes.no_link.label')),
        className: "m-top-0"
      }, _react.default.createElement(_UITextInput.default, {
        disabled: true,
        value: _I18n.default.text(i18nKey('linkTypes.no_link.placeholder'))
      }));
    }
  }, {
    key: "renderUrlField",
    value: function renderUrlField() {
      var linkType = this.props.linkType;

      switch (linkType) {
        case _link.LinkTypes.URL:
          return this.renderUrlSearchInput();

        case _link.LinkTypes.PAGE:
          return this.renderPageSelection();

        case _link.LinkTypes.EMAIL:
          return this.renderEmailInput();

        case _link.LinkTypes.FILE:
          return this.renderFileSelection();

        case _link.LinkTypes.EMAIL_SUBSCRIPTION:
          return this.renderEmailSubscriptionSelection();

        case _link.LinkTypes.MEETING:
          return this.renderMeetingSelection();

        case _link.LinkTypes.ANCHOR:
          return this.renderAnchorInput();

        case _link.LinkTypes.NONE:
          return this.renderNoLinkInput();

        default:
          return null;
      }
    }
  }, {
    key: "renderLinkSelection",
    value: function renderLinkSelection() {
      var _this$props9 = this.props,
          linkType = _this$props9.linkType,
          useEmailSubscription = _this$props9.useEmailSubscription,
          allowFileDownload = _this$props9.allowFileDownload,
          allowMeetingLink = _this$props9.allowMeetingLink,
          allowAnchorLinks = _this$props9.allowAnchorLinks,
          useNoLinkOption = _this$props9.useNoLinkOption,
          dropdownClassName = _this$props9.dropdownClassName,
          allowPageLinks = _this$props9.allowPageLinks;
      var linkTypeOptions = [{
        text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL + ".option")),
        value: _link.LinkTypes.EMAIL
      }, {
        text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.URL + ".option")),
        value: _link.LinkTypes.URL
      }];

      if (allowFileDownload) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.FILE + ".option")),
          value: _link.LinkTypes.FILE
        });
      }

      if (allowPageLinks) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.PAGE + ".option")),
          value: _link.LinkTypes.PAGE
        });
      }

      if (useEmailSubscription) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL_SUBSCRIPTION + ".option")),
          value: _link.LinkTypes.EMAIL_SUBSCRIPTION
        });
      }

      if (allowMeetingLink) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.MEETING + ".option")),
          value: _link.LinkTypes.MEETING
        });
      }

      if (allowAnchorLinks) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.ANCHOR + ".option")),
          value: _link.LinkTypes.ANCHOR
        });
      } // re-order alphabetically based on option label


      linkTypeOptions.sort(_link2.alphabeticalSort); // place no-link at the top since it's the default zero-state

      if (useNoLinkOption) {
        linkTypeOptions.unshift({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.NONE + ".option")),
          value: _link.LinkTypes.NONE
        });
      }

      return _react.default.createElement("div", null, _react.default.createElement(_UIFormControl.default, {
        className: "m-bottom-1",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('linkTo')
        })
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        menuStyle: {
          maxHeight: 300
        },
        value: linkType,
        placeholder: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('linkTypes.placeholder')
        }),
        options: linkTypeOptions,
        defaultValue: "url",
        searchable: false,
        "data-test-id": "link-type-select",
        onChange: this.handleLinkTypeChange,
        optionRenderer: function optionRenderer(option) {
          return _react.default.createElement(_StyleProtectedSelectItem.default, {
            title: option.text
          }, _react.default.createElement("span", null, option.text));
        }
      })), this.renderUrlField());
    }
  }, {
    key: "renderCheckboxes",
    value: function renderCheckboxes() {
      var _this$props10 = this.props,
          externalLink = _this$props10.externalLink,
          noFollow = _this$props10.noFollow,
          linkType = _this$props10.linkType,
          showRefAndTargetControls = _this$props10.showRefAndTargetControls,
          onUpdate = _this$props10.onUpdate,
          useContextualToolbar = _this$props10.useContextualToolbar,
          tooltipClassName = _this$props10.tooltipClassName;

      if (useContextualToolbar && showRefAndTargetControls) {
        var handleChange = function handleChange(_ref7) {
          var checked = _ref7.target.checked;
          onUpdate({
            externalLink: checked
          });
        };

        var readOnly = _link.ReadOnlyLinkTypes.includes(linkType);

        return _react.default.createElement(_UICheckbox.default, {
          className: "m-top-3",
          size: "small",
          checked: externalLink || linkType === _link.LinkTypes.EMAIL,
          readOnly: readOnly,
          disabled: linkType === _link.LinkTypes.NONE,
          onChange: handleChange
        }, _react.default.createElement(_UITooltip.default, {
          className: tooltipClassName,
          title: _I18n.default.text(i18nKey('openNewWindowReadOnly'), {
            linkType: linkType
          }),
          placement: "top",
          disabled: !readOnly
        }, _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('openNewWindow')
        })));
      }
      /**
       * @TODO Remove this once `useContextualToolbar` is fully ungated
       */


      if (!showRefAndTargetControls || linkType === _link.LinkTypes.NONE) return null;
      var showOpenNewWindow = linkType !== _link.LinkTypes.EMAIL && linkType !== _link.LinkTypes.FILE && linkType !== _link.LinkTypes.ANCHOR;
      return _react.default.createElement("div", {
        className: "m-top-2"
      }, showOpenNewWindow ? _react.default.createElement("div", {
        className: "justify-between align-center"
      }, _react.default.createElement(_UICheckbox.default, {
        size: "small",
        checked: externalLink,
        onChange: function onChange(_ref8) {
          var checked = _ref8.target.checked;
          onUpdate({
            externalLink: checked
          });
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('openNewWindow')
      }))) : null, _react.default.createElement("div", {
        className: "justify-between align-center"
      }, _react.default.createElement(_UICheckbox.default, {
        size: "small",
        checked: noFollow,
        description: _react.default.createElement(_UIHelpIcon.default, {
          title: _I18n.default.text(i18nKey('noFollowPopover')),
          tooltipProps: {
            placement: 'top'
          }
        }),
        descriptionLayout: "horizontal",
        onChange: function onChange(_ref9) {
          var checked = _ref9.target.checked;
          onUpdate({
            noFollow: checked
          });
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('tellNoFollow')
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, this.renderLinkSelection(), this.renderCheckboxes());
    }
  }]);
  return LinkFields;
}(_react.Component);

exports.default = LinkFields;
LinkFields.propTypes = {
  externalLink: _propTypes.default.bool.isRequired,
  noFollow: _propTypes.default.bool.isRequired,
  href: _propTypes.default.string.isRequired,
  onUpdate: _propTypes.default.func.isRequired,
  onLinkTypeChange: _propTypes.default.func.isRequired,
  fetchPages: (0, _requiredBy.default)('allowPageLinks', _propTypes.default.func),
  fetchMeetingsByUsers: (0, _requiredBy.default)('allowMeetingLink', _propTypes.default.func),
  fetchAnchors: (0, _requiredBy.default)('allowAnchorLinks', _propTypes.default.func),
  linkType: _propTypes.default.oneOf(Object.values(_link.LinkTypes)),
  onSelectFile: (0, _requiredBy.default)('allowFileDownload', _propTypes.default.func),
  onUrlKeyDown: _propTypes.default.func.isRequired,
  currentFileMeta: _propTypes.default.object,
  dropdownClassName: _propTypes.default.string,
  showRefAndTargetControls: _propTypes.default.bool,
  useEmailSubscription: _propTypes.default.bool,
  allowFileDownload: _propTypes.default.bool,
  allowMeetingLink: _propTypes.default.bool,
  emailSubscriptionLinkTypes: _propTypes.default.array,
  allowAnchorLinks: _propTypes.default.bool,
  allowPageLinks: _propTypes.default.bool,
  useNoLinkOption: _propTypes.default.bool,
  shouldAutoFocus: _propTypes.default.bool,
  userId: _propTypes.default.number,
  isValidLink: _propTypes.default.bool,
  useContextualToolbar: _propTypes.default.bool,
  tooltipClassName: _propTypes.default.string
};
LinkFields.defaultProps = {
  useEmailSubscription: false,
  allowFileDownload: true,
  allowAnchorLinks: false,
  allowPageLinks: false,
  useNoLinkOption: false,
  shouldAutoFocus: true,
  isValidLink: true
};
module.exports = exports.default;